module.exports = "https://trybtryb-legacy.web.app/img/link-bio.0f9d30ba.webp";